// extracted by mini-css-extract-plugin
export var icon = "_6i-1";
export var subtext = "_6i-0";